import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Map, Newspaper, Trophy, User } from 'lucide-react';

const TABS = [
  { id: 'map', path: '/map', icon: Map, label: 'Carte' },
  { id: 'feed', path: '/feed', icon: Newspaper, label: 'Feed' },
  { id: 'challenges', path: '/challenges', icon: Trophy, label: 'Défis' },
  { id: 'profile', path: '/profile', icon: User, label: 'Profil' },
];

export default function BottomTabBar({ unviewedChallengesCount = 0, onTabClick }) {
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveTab = () => {
    const path = location.pathname;
    if (path.startsWith('/feed')) return 'feed';
    if (path.startsWith('/challenges')) return 'challenges';
    if (path.startsWith('/profile')) return 'profile';
    // Default to map for /, /map, /court, etc.
    return 'map';
  };

  const activeTab = getActiveTab();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 bg-[#0B0D12]/95 backdrop-blur-md border-t border-white/5"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="flex justify-around items-center h-12 max-w-lg mx-auto">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          const showBadge = tab.id === 'challenges' && unviewedChallengesCount > 0;

          return (
            <button
              key={tab.id}
              onClick={() => onTabClick ? onTabClick(tab.id) : navigate(tab.path)}
              className={`flex items-center justify-center flex-1 h-full relative transition-colors ${
                isActive ? 'text-[#6E2BFF]' : 'text-[#9CA0AB] hover:text-white'
              }`}
            >
              <div className="relative">
                <Icon className={`w-6 h-6 ${isActive ? 'drop-shadow-[0_0_8px_rgba(110,43,255,0.6)]' : ''}`} />
                {showBadge && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[16px] h-[16px] flex items-center justify-center px-0.5 animate-pulse">
                    {unviewedChallengesCount > 9 ? '9+' : unviewedChallengesCount}
                  </span>
                )}
              </div>
              {isActive && (
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-[#6E2BFF] rounded-full" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
